module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "dedication",
      "role": "doc-dedication"
    }
  }, [_c('p', {
    staticClass: "Dedication-ded",
    attrs: {
      "id": "ded"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "v",
      "id": "pg_v",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("This year has been a tough one everywhere. New York, especially, has been hit hard by COVID-19. But the city is no stranger to crisis, and once again, New Yorkers are rising to the occasion. This book is dedicated to the city of New York: to the health workers, scientists, public servants, and volunteers on the frontlines of the crisis; to the essential workers of all stripes, from teachers to bus drivers to grocery store clerks putting themselves at risk to keep the city running; to the ordinary New Yorkers going out of their way for their friends and neighbors and strangers in need. You are, as always, an inspiration.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d6dd37b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 69
// module chunks = 0